module.exports = __webpack_public_path__ + "media/images/menu-item-cover-725b194b23c4cf8971c18dc9437698b7.png";